<template>
  <div class="public-bus">
    <div class="scroll-wrapper" ref="scroll">
      <ul class="scroll-content">
        <li class="scroll-item" v-for="(item, index) in lineStationArr" :key="index" ref="lis">
          <!-- {{item}} -->
          <div class="stationbusBox">
             
            <bus :stationItem="item" :allBus="allBus"/>
          </div>
          <div class="station">
            <div class="line" :style="{background:'#' + colorList[index]}"></div>
            <div class="lineName" @click="stationClick(item)">
               <div class="lineCircle" v-if="activeStation === item.seq * 1"><img src="../../../assets/image/lineCurrent.png" class="circleImg" ></div>
               <div class="lineCircle" v-else><img src="../../../assets/image/lineCircle.png" class="circleImg" ></div>
              
              <!-- <div :class="{activeStation: activeStation === item.seq * 1, currentStation: currentStation === item.seq * 1}">
                <div class="circle" v-if="currentStation !== item.seq * 1" :style="{border: `2px solid #${colorList[index]}`}">
                  <div class="iconfont icon-daohang1" v-if="activeStation === item.seq * 1"></div>
                </div>
                <div class="circle" v-if="currentStation === item.seq * 1">
                  <div class="current">最近</div>
                  <div class="iconfont icon-daohang1" v-if="activeStation === item.seq * 1"></div>
                </div>
              </div> -->
              <div class="station-name" :class="[activeStation === item.seq * 1 ? 'lightColor': 'weightColor']">
                <div class="num">{{item.seq*1 >= 10 ? item.seq : `0${item.seq}`}}</div>
                <div class="name">{{item.stationName}}</div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import BScroll from 'better-scroll'
import { mixin } from '@/mixins'
import { mapGetters } from 'vuex'
import {decodeBusSeq, decodeLatLng, decodeBusNum} from '@/utils/transform'
import bus from './bus'
export default {
  mixins: [mixin],
  components: { bus },
  data () {
    return {
      scrollWidth: 0, // 手机宽度
      lineStationArr: [], // 站点,
      colorList: [], // 车路情况
      myWidth: 80,
      timer: null, // 定时器
      currentStation: 1, // 最近站点
      activeStation: 1, // 点击更换其他站点
      saveActiveStation: null, // 保存当前点击的站点
      allBus: [] // 所有线上车辆
    }
  },
  props: {
    lineBasicInfo: {
      type: Object
    },
    nearSeq:{
      type:String
    }
  },
  watch: {
    lineBasicInfo: {
      handler: function (val) {
        if (val) {
          this.initAllData(val)
        }
      },
      immediate: true
    },
   
  },
  beforeRouteLeave(to, from, next){
    next()
    clearInterval(this.timer)
     this.timer = null
  },
  computed: {
    ...mapGetters([])
  },
  mounted(){},
  methods: {
    // 初始化数据，并且打开定时器
    initAllData (obj) {
      if (obj.lineStationList) {
        this.scrollWidth = document.body.scrollWidth
        // this.colorList = obj.stationInterval.map(item => item.color)
        const lineStation = this.lineStationArr = obj.lineStationList
        
        this.currentStation = this.nearSeq*1
        this.activeStation = this.saveActiveStation ? this.findStation(lineStation, this.saveActiveStation, this.nearSeq * 1) : this.nearSeq*1 
        this.saveActiveStation = lineStation[this.activeStation - 1]
         this.$emit("selectStation", this.saveActiveStation)
        // 获取最近两辆车
        this.getTwoBus()
        this.getBusInfo()
        this.$nextTick(() => {
          this.bs = new BScroll(this.$refs.scroll, {
            scrollX: true,
            click: true,
            tap: true,
            eventPassthrough: 'vertical', // 保持纵向的原生浏览器滚动
            probeType: 3 // listening scroll event
          })
          //  this.bs.refresh()
          //默认滑动当前站的位置
          let a = document.querySelector(".scroll-item .lightColor")
          this.bs.scrollToElement(a, 0, -this.scrollWidth/2)
        })
        // 开启定时器
        this.startTimer()
      }
      
    },
   
    
    // 获取最近两辆车的数据
    getTwoBus () {
       let lineParams = []
       lineParams = [{
        businessType: this.lineBasicInfo.businessType, // 业务类型 ,1普通公交,2定制公交
        dirctionType: this.lineBasicInfo.dirctionType, // 上下行  1 上行  2 下行
        lineCode: this.lineBasicInfo.lineCode, // 线路编码
        lineType: this.lineBasicInfo.lineType, // 线路类型,1主线2区间3支线4大站快车
        lineStationId:this.saveActiveStation.lineStationId
      }]
      this.$api['station.timetable'](lineParams).then(res=>{
        if (res.length) {
            let firstData = res[0].busPosition
            this.twoBusList = firstData.map(item => {
            let obj = {
              seq: this.activeStation - item.seq * 1,
              distance: this.distance(item.distance * 1),
              distanceName: this.distanceName(item.distance * 1),
              runTime: this.runTime(item.runTime * 1),
              runTimeName: this.runTimeName(item.runTime * 1)
            }
           
            return Object.assign({}, item, obj)
          })
          this.$emit('twoBusBack', this.twoBusList)
        
        } else {
           this.$emit('twoBusBack', this.twoBusList)
        }
      })
    },
    distance (distance) {
      return distance >= 1000 ? (distance / 1000).toFixed(1) : distance
    },
    distanceName (distance) {
      return distance >= 1000 ? '公里': '米'
    },
    runTime (runTime) {
      return runTime >= 60 ?  (runTime  / 60).toFixed(0)  : runTime
    },
    runTimeName (runTime) {
      return runTime >= 60 ?  '分钟' : '秒'
    },
      // 站点点击事件
    stationClick (item) {
      this.activeStation = item.seq * 1
      this.saveActiveStation = item // 缓存该站点以便刷新和换向记住该站点
      this.$emit("selectStation", this.saveActiveStation)
      // 获取最近两辆车
      this.getTwoBus()
    },
    // 车辆位置
    getBusInfo () {
      const params = {
        businessType: this.lineBasicInfo.businessType, // 业务类型 ,1普通公交,2定制公交
        dirctionType: this.lineBasicInfo.dirctionType, // 上下行  1 上行  2 下行
        lineCode: this.lineBasicInfo.lineCode, // 线路编码
        lineType: this.lineBasicInfo.lineType, // 线路类型,1主线2区间3支线4大站快车
      }
      this.$api['station.busPosition'](params).then(res => {
        if (res.length) {
          this.allBus = res.map(item => {
            // 解析站序 和 经纬度
            let obj = {
              seq: decodeBusSeq(item.seq),
              lat: decodeLatLng(item.latitude),
              lng: decodeLatLng(item.longitude),
              busNum: decodeBusNum(item.busNum)
            }
            return Object.assign({}, item, obj)
          })
          console.log(this.allBus)
        } else {
          this.allBus = []
        }
      })
    },
       // 找到切换方向后的站点
    findStation (arr, obj, num) {
      if (obj) {
        const target = arr.find(item => {
          return item.stationName === obj.stationName
        })
        if (target) {
          return target.seq * 1
        } else {
          return num
        }
      } else {
        return num
      }
    },
    // 换向 关闭定时器
    changeDirction () {
      clearInterval(this.timer)
    },
    startTimer () {
      this.timer = setInterval(() => {
        this.getTwoBus()
        this.getBusInfo()
        // this.getColor()
      }, 1000 * 10)
    },
     // 刷新 关闭定时器
    refresh () {
      clearInterval(this.timer)
      this.getTwoBus()
      this.getBusInfo()
      setTimeout(() => {
        this.startTimer()
      }, 300)
    }
 
  }
}
</script>
<style lang="scss">
$myWidth: 80px;
$basicColor: #2196F6;

.public-bus {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding-top:18px;
  box-sizing: border-box;
  .scroll-wrapper {
    width: 100%;
    height: auto;
    white-space: nowrap;
    overflow: hidden;
    .scroll-content {
      display: inline-block;
      .scroll-item {
        display: inline-block;
        width: $myWidth;
        height: 100%;
        min-height: 250px;
        .stationbusBox {
          width: $myWidth;
          height: 50px;
        }
        .station {
          width: $myWidth;
          height: auto;
          position: relative;
        }
      }
      .scroll-item:first-child {
        margin-left: 30px;
        .circle {
          background:#16a951;
          border: 2px solid#16a951 !important;
        }
      }
      .scroll-item:last-child {
        width: 40px;
        .stationbusBox {
          .bus-pos {
            display: none;
          }
        }
        .circle {
          background:#f00056;
          border: 2px solid #f00056 !important;
        }
        .line {
          background: #ffffff;
        }
      }
      .line {
        width: $myWidth;
        height:6px;
        background:#22B2ED;
      }
      .lineName {
        width: $myWidth;
        .lineCircle{
           width:14px;
           height:14px;
          .circleImg{
            width: 100%;
            height: 100%;
            display: block;
            position: relative;
            top: -10px;
            left:-6px;
          }
        }
        .station-name {
          position: absolute;
          top: 15px;
          left:-10px;
          text-align: center;
          font-size: 16px;
           .name {
            writing-mode: vertical-lr;
           }
        }
        .weightColor {
            color: #333
          }
          .lightColor {
            color: #FFAF28;
          }
        .circle {
          background-image:url('../../../assets/image/lineCircle.png') ;
          z-index: 100;
          position: absolute;
          top: -4px;
          left: -6px;
        }
        // 选中的样式
        .activeStation {
          .circle {
            width: 15px;
            height: 15px;
            // background: #ffffff !important;
            border: 2px solid #FFAF28 !important;
            top: -9px;
            left: -11px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #FFAF28;
            .iconfont {
              width: 5px;
              height: 5px;
              font-size: 12px;
              color:#fff;
              transform: rotate(45deg) translate(-4px, 1px);
              line-height: 5px;
              text-align: center;
            }
          }
        }
        // 当前的样式
        .currentStation {
          .circle {
            width: 30px;
            height: 15px;
            background: #ffffff !important;
            font-size: 12px;
             border: 2px solid $basicColor !important;
            border-radius: 10px;
            top: -10px;
            left: -15px;
            display: flex;
            justify-content: center;
            align-items: center;
            .current {
              transform: scale(0.8);
              color: $basicColor;
            }
          }
        }
        // 当前选中的样式
        .currentStation.activeStation {
          .circle {
            width: 50px;
            height: 20px;
            background: #ffffff !important;
            font-size: 12px;
            border: 3px solid $basicColor !important;
            color: $basicColor;
            border-radius: 20px;
            top: -12px;
            left: -28px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }
}

</style>
